import { createSelector } from "reselect";

const getRights = state => state.user?.profile?.rights;

export const userHasRight = right => {
  return createSelector(
    [getRights],
    rights => !!rights?.includes(right),
  );
};

export const userHasAnyRight = (...rights) => {
  return createSelector(
    [getRights],
    userRights => !!rights?.some(r => userRights.includes(r)),
  );
};